import debounce from 'lodash/debounce'

const MARGIN_UNIT = 0.125
let progressBar, slideWidth, totalNumberOfSlides, totalWidth

export const onResize = debounce(invalidateScrollMemoization, 300)

function invalidateScrollMemoization (_event) {
  onScroll(false)
}

export function onScroll (event) {
  if (!event) {
    progressBar = slideWidth = totalNumberOfSlides = totalWidth = 0
    return
  }

  totalNumberOfSlides = totalNumberOfSlides || event.target.querySelectorAll('.Journey').length - 1
  totalWidth = totalWidth || event.target.scrollWidth
  slideWidth = slideWidth || event.target.offsetWidth

  const { scrollLeft } = event.target
  const offset = scrollLeft / slideWidth
  const value = normalize(offset, totalNumberOfSlides)

  if (!progressBar) {
    progressBar = event.target.querySelector('.ProgressBar')
    progressBar.style.left = `calc(${MARGIN_UNIT * Math.PI}em + ${slideWidth * 100 / totalWidth}%)`
    progressBar.style.width = `calc(100% - ${100 / (totalNumberOfSlides + 1)}% - ${MARGIN_UNIT * 5}em - ${MARGIN_UNIT * totalNumberOfSlides}em)`
  }
  progressBar.style.transform = `scaleX(${value})`
}

function normalize (val, max, min = 0) {
  return (val - min) / (max - min)
}
